<!--
Copyright 2024 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the
project root for license information.
-->
<crucible-dialog
  [dialogTitle]="(data.isNewInject ? 'Create' : 'Edit') + ' an Inject'"
  [submitDisabled]="!errorFree()"
  [guardUnsavedWork]="true"
  (cancel)="handleEditComplete(false)"
  (submit)="handleEditComplete(true)"
>
  @if (!!data && data.inject !== undefined && data.inject !== null) {
    <div crucibleDialogContent>
      <!-- name -->
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Name</mat-label>
            <input
              type="text"
              title="The Name of the Inject"
              matInput
              placeholder="Name (required)"
              [(ngModel)]="data.inject.name">
          </mat-form-field>
        </div>
      </div>
      <!-- description -->
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Description</mat-label>
            <input
              type="text"
              title="The Description of the Inject"
              matInput
              placeholder="Description (required)"
              [(ngModel)]="data.inject.description">
          </mat-form-field>
        </div>
      </div>
      <!-- requires inject -->
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Prerequisite Inject</mat-label>
            <mat-select placeholder="Prerequisite Inject" [(ngModel)]="data.inject.requiresInjectId">
              <mat-option [value]="null" title="None"></mat-option>
              @for (inject of otherInjects(data.inject.id); track inject) {
                <mat-option [value]="data.inject.id" title="{{ data.inject.name}}">
                  {{ inject.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      @for (dataField of data.dataFieldList; track dataField) {
        <div class="add-margin">
          <div class="full-width">
            <app-data-value
              [(value)]="getDataValue(dataField.id).value"
              [dataField]="dataField"
              [canEdit]="data.isEditMode"
              [canApprove]="false"
              [isOwner]="false"
              [showValueOnly]="!data.isEditMode"
              [organizationOptions]="[]"
              [teamOptions]="[]"
              [unitOptions]="data.unitList"
              [cardOptions]="[]"
              [moveOptions]="[]"
              [gallerySourceTypeOptions]="[]"
              [galleryItemStatusOptions]="[]"
              [userOptions]="data.userList"
            ></app-data-value>
            <br />
          </div>
        </div>
      }
    </div>
  }
</crucible-dialog>
